<template>
<div id="address_map" class="address-google-map"></div>
</template>

<script>

    export default {

        props: {
            value: {
                default: null,
            },
        },

        data ()
        {
            return {
                map: null,
                marker: null,
            }
        },

        watch: {

            value (value)
            {
                this.setMarker(value)
            }

        },

        mounted ()
        {
            this.map = new google.maps.Map(document.getElementById('address_map'), {
                center: {
                    lat: 62,
                    lng: 15
                },
                scrollwheel: false,
                zoom: 5
            });

            this.setMarker(this.value)
        },

        methods: {

            zoomToMarker ()
            {
                this.map.setZoom(14);
                this.map.setCenter(this.marker.getPosition());
            },

            setMarker(coordinates)
            {
                if (!coordinates) {
                    return
                }

                if (this.marker) {
                    this.marker.setMap(null)
                }

                const split = coordinates.split(' ')
                const position = new google.maps.LatLng(split[0], split[1])

                console.log('set marker at')
                console.log(position)

                this.marker = new google.maps.Marker({
                    map: this.map,
                    position: position,
                    draggable: true,
                });

                this.marker.addListener('dragend', () => {
                    console.log('marker has been moved to')
                    console.log(this.marker.getPosition().lat()+' '+this.marker.getPosition().lng())

                    this.$emit('input', this.marker.getPosition().lat()+' '+this.marker.getPosition().lng())
                })
            }

        }

    }

</script>
